<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['contact-section-skeleton', { _mobile: isMobile }]">
    <div class="contact-section-skeleton__header">
      <Skeleton :width="isMobile ? '100%' : '270px'" height="100px" />
      <Skeleton v-if="!isMobile" width="235px" height="45px" />
    </div>
    <Skeleton width="100%" :height="isMobile ? '159px' : '220px'" />
  </div>
</template>

<style lang="less" scoped>
.contact-section-skeleton {
  .flex-column(@size-x8);
  .box-shadow();

  padding: @size-x8;

  &__header {
    display: flex;
    justify-content: space-between;
    gap: @size-x8;
  }

  &._mobile {
    padding: @size-x5;
  }
}
</style>
